import { connect } from "react-redux";
import { ProtocolOverview as ProtocolOverviewModal } from "@learningblocks/simulations/shared-components/lib/ProtocolModals/ProtocolOverview";

interface ModalState {
  dialysisConcentration: any;
  selectedConcentration: number;
}

const mapStateToProps = (state: ModalState) => {
  return {
    concentration: state.dialysisConcentration.concentration,
    title: "Read through the protocol",
    steps: [
      "Take the initial mass of the dialysis tubes.",
      "Place each dialysis tube into a beaker.",
      "After 30 minutes, measure the final mass of the dialysis tubes.",
    ],
    buttonText: "Start simulation",
  };
};

export default connect(mapStateToProps)(ProtocolOverviewModal);
